import { Navigate, Route, Routes } from 'react-router-dom';

import { Users } from './Users';
import { User } from './User';
import { SearchResults } from './SearchResults';

export const UsersRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<Users />} />
      <Route path=":id" element={<User />} />
      <Route path="search-results" element={<SearchResults />} />
      <Route path="*" element={<Navigate to="." />} />
    </Routes>
  );
};
